import { TravelCurrencyCode } from '@graphql/generated';
import { useGeoBasedLocale } from './useGeoLocale';

export const useTravelWhiteLabelCurrency = (): TravelCurrencyCode => {
  const { currency: localeCurrency } = useGeoBasedLocale();

  const currency = localeCurrency as keyof typeof TravelCurrencyCode;
  const validCurrencyCode = TravelCurrencyCode[currency] || TravelCurrencyCode.USD;

  return validCurrencyCode;
};
